<div class="root">
    <span class="expander" (click)="toggleExpanded()">
        {{isExpanded ? 'V' : '>'}}
    </span> <b>{{index}}. {{party.partyId || "Unknown Party"}}</b> : {{party.participantType}}, {{party.interactionId}} (isRemoved: {{party.removalDetails.isRemoved}})
    <div class="details" *ngIf="isExpanded">
        <ul>
            <li>partyId: {{party.partyId}}</li>
            <li>interactionId: {{party.interactionId}}</li>
            <li>scenarioId: {{party.scenarioId}}</li>
            <li>participantType: {{party.participantType}}</li>
            <li>phoneNumber: {{party.phoneNumber}}</li>
            <li>Removal Details: isRemoved: {{party.removalDetails.isRemoved}}, preserveCalls: {{party.removalDetails.preserveOtherCalls}}</li>
        </ul>
    </div>
</div>